import { PageId } from 'constants/pages'

export const enum PageIdWoofzHlwn65 {
  SUBSCRIPTIONS_PAGE_HLWN_65 = PageId.SUBSCRIPTIONS_PAGE_HLWN_65,
  CHAT_UPSELL_HLWN_65 = PageId.CHAT_UPSELL_HLWN_65,
  UPSELL_HLWN_65 = PageId.UPSELL_HLWN_65,
  DOWNLOAD_HLWN_65 = PageId.DOWNLOAD_HLWN_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
